<template>
  <div :class="style.wrapper">
    <h3 :class="style.basicTitle">残日数</h3>
    <div :class="variableClass">
      <span :class="style.bigNumber">{{ remainingDays }}</span>
      <span :class="style.unit">日</span>
    </div>
  </div>
</template>

<script>
import { cx } from 'emotion'
import {
  remainingDaysStyle,
  baseStyle,
} from '@/components/Advertiser/Report/BudgetProgressReport/Reminder/reminderStyles'
import getBPLength from '@/components/Advertiser/Report/BudgetProgressReport/Reminder/getBPLength'

export default {
  name: 'Reminder',
  props: {
    data: Object,
  },
  computed: {
    remainingDays() {
      if (!this.data) return 0
      return this.data.remainingDays || 0
    },
    variableClass() {
      return cx(
        baseStyle.variable,
        remainingDaysStyle(this.remainingDays, getBPLength(this.data)),
      )
    },
    style() {
      return baseStyle
    },
  },
}
</script>

<style></style>
